import React from 'react';
import DatePicker from 'react-datepicker';
import ScannerTable from './ScannerTable';
import FilterDropdown from '../FilterDropdown/FilterDropdown';
import AllFilters from '../Filters/AllFilters';
import MultiScreenRange from '../Filters/Fields/MultiScreenRange';
import 'react-datepicker/dist/react-datepicker.css';

const moment = require('moment');

const Scanner = ({group, multiScreen, dispatch, hasChild}) => {
  const handleUpdateMultiSelect = (value, type, field) => {
    const {searchValue} = group;
    const newSearchValueCopy = {...searchValue};
    const findFieldToUpdate = newSearchValueCopy.filters.find(
      (filter) => filter?.key === type,
    );

    if (findFieldToUpdate && findFieldToUpdate.value) {
      const updateWith = {
        updatedValue: value
          ? [...findFieldToUpdate.value, field]
          : findFieldToUpdate.value.filter((filter) => filter !== field),
        key: type,
        minMax: null,
        group,
      };
      dispatch({
        type: 'UPDATE_FILTER_VALUES',
        payload: updateWith,
      });
    }
  };

  const disableDays = (current) => {
    const june = moment().set({year: 2022, month: 4, date: 31}).toDate();
    const day = moment(current).day();
    return day !== 0 && day !== 6 && current >= june;
  };

  const formatDate = (date) => {
    const timestamp = Date.parse(date);
    if (Number.isNaN(timestamp)) return new Date();
    const selectedToMomentDay = moment(date, 'YYYY-MM-DD');
    const june = moment().set({year: 2022, month: 4, date: 31});
    const day = selectedToMomentDay.day();
    // If not weekend and after June 31st, return date
    if (day !== 0 && day !== 6 && !moment(selectedToMomentDay).isBefore(june)) {
      return selectedToMomentDay.toDate();
    }
    return new Date();
  };

  const handleDatePickerChange = (date) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    dispatch({type: 'CHANGE_GROUP_DATE', payload: {newDate, group}});
  };

  return (
    <div className={`${hasChild ? 'hasChild pb-7' : ''} scanner-wrap `}>
      {group ? (
        <div className="scanner">
          <div
            className={`${
              multiScreen ? 'text-2xl' : 'text-4xl'
            } flex items-center justify-center my-4  group-title`}
          >
            <h1>{group?.groupTitle}</h1>
          </div>

          <div className="flex items-end flex-col lg:flex-row filter-btn my-4 filter-row gap-4 mx-auto group-header">
            {group?.searchValue?.filters?.length ? (
              <AllFilters
                filters={group?.searchValue?.filters}
                group={group}
                handleUpdateMultiSelect={handleUpdateMultiSelect}
                dispatch={dispatch}
                multiScreen={multiScreen}
              />
            ) : null}

            {group?.selectedDate && group?.showDateSelector ? (
              <div className="  flex flex-col w-full  gap-2">
                <p className="block text-md font-medium text-gray-700">
                  Select Date
                </p>
                <div className="rounded-md bg-white shadow-sm ">
                  <div className="mt-1">
                    <DatePicker
                      filterDate={disableDays}
                      selected={formatDate(group?.selectedDate ?? null)}
                      onChange={handleDatePickerChange}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {group?.searchValue?.filters?.filter(
              (filter) => filter && filter?.filterable?.type === 'range',
            ).length && multiScreen ? (
              <div>
                <MultiScreenRange
                  group={group}
                  dispatch={dispatch}
                  filters={group?.searchValue?.filters.filter(
                    (filter) => filter && filter?.filterable?.type === 'range',
                  )}
                />
              </div>
            ) : null}

            {group?.searchValue?.boolFilters?.length ||
            group?.searchValue?.additionalFilters?.length ||
            group?.showBearBullFilter ? (
              <div className="flex flex-col w-full gap-4">
                <FilterDropdown
                  group={group}
                  additionalFields={[
                    ...(group?.searchValue?.additionalFilters ?? []),
                    ...(group?.searchValue?.boolFilters ?? []),
                  ]}
                  showBearBullFilter={group?.showBearBullFilter}
                  activeFilter={group?.activeFilter}
                  dispatch={dispatch}
                  multiScreen={multiScreen}
                />
              </div>
            ) : null}
          </div>
          <p className="mb-3 text-black">Del-15</p>

          <ScannerTable
            tableData={group?.filteredData ?? {}}
            dataTypes={group?.dataTypes ?? []}
            orderBy={group?.orderBy}
            group={group}
            page={group?.page}
            multiScreen={multiScreen}
            order={group?.order}
            rowsPerPage={group?.rowsPerPage}
            dispatch={dispatch}
          />
        </div>
      ) : (
        <div className="scanner"> Loading Scanner... </div>
      )}
    </div>
  );
};

export default Scanner;
